import { useIsSmallViewportWidth } from '@hqo/react-components-library/dist/viewport';
import { useFilteringEnabled } from 'hooks/use-filtering-enabled.hook';
import { useResourceLoadingHandler } from 'pages/resources/hooks';
import { useCallback, useMemo } from 'react';
import { useCurrentConfig } from 'hooks/use-current-config.hook';
import { useIntl } from 'react-intl';
import { goBack } from 'store/router/actions';
import { resetResourcesState } from 'store/resources/actions';
import { useDispatch } from 'react-redux';

interface UseHeaderReturnValues {
  currentConfigName: string;
  isHeaderVisible: boolean;
  onPressBack: VoidFunction;
}

export const useHeader = (): UseHeaderReturnValues => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const isMobileDevice = useIsSmallViewportWidth();
  const isFilteringEnabled = useFilteringEnabled();
  const isLoadingState = useResourceLoadingHandler(isFilteringEnabled);
  const currentConfig = useCurrentConfig();
  const currentConfigName = useMemo<string>(
    () => currentConfig?.name || intl.formatMessage({ id: 'mySuite' }),
    [currentConfig, intl],
  );
  const isHeaderVisible = useMemo(() => !isMobileDevice && !isLoadingState, [isLoadingState, isMobileDevice]);

  const onPressBack = useCallback(() => {
    dispatch(goBack());
    dispatch(resetResourcesState());
  }, [dispatch]);

  return {
    currentConfigName,
    isHeaderVisible,
    onPressBack,
  };
};
